import React from 'react';
import { Link } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';
import styled from 'styled-components';

import Instagram from '../InstragramButton';
import MenuButton from '../MenuButton';
import colors from '../../styles/colors';
import shopLogo from '../../photos/shop_logo_white.jpg';
import { Typography } from '@material-ui/core';

const ShopLogo = styled.img`
    max-width: 100px;
    height: 60px;
`;

const ToolbarHeader = styled(Toolbar)`
    min-height: 80px;
    display: flex;
    justify-content: space-evenly;
    ${props => props.theme.breakpoints.down('xs')} {
        justify-content: space-between;
    }
`;

const LinkWrapper = styled.div`
    flex: 0 1 15%;
    text-align: center;
`;

const LinkHeader = styled(Link)`
    text-decoration: none;
    color: ${colors.white};
    &:hover {
        text-decoration: underline
    }
`;

const Header = () => {

    return (
        <AppBar position="sticky">
            <ToolbarHeader>
                <LinkWrapper>
                    <LinkHeader to="/">
                        <ShopLogo src={shopLogo}></ShopLogo>
                    </LinkHeader>
                </LinkWrapper>
                <Hidden xsDown>
                    <LinkWrapper>
                        <LinkHeader to="/about">
                            <Typography variant="subtitle1">小麦屋について</Typography>
                        </LinkHeader>
                    </LinkWrapper>
                    <LinkWrapper>
                        <LinkHeader to="/gallery">
                            <Typography variant="subtitle1">ギャラリー</Typography>
                        </LinkHeader>
                    </LinkWrapper>
                    <LinkWrapper>
                        <LinkHeader to="/access">
                            <Typography variant="subtitle1">アクセス</Typography>
                        </LinkHeader>
                    </LinkWrapper>
                    <LinkWrapper><Instagram /></LinkWrapper>
                </Hidden>
                <Hidden smUp>
                    <MenuButton />
                </Hidden>
            </ToolbarHeader>
        </AppBar>
    )
}

export default Header;